module.exports = __webpack_public_path__ + "static/media/credentialing.20809654.svg";